/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Commandautomatep12Inputs */



/**
* | output |
* | --- |
* | "Left/top pump controller command" |
*
* @param {Ahu_History_Key_Commandautomatep12Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_commandautomatep12 = /** @type {((inputs?: Ahu_History_Key_Commandautomatep12Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Commandautomatep12Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Left/top pump controller command")
	return /** @type {LocalizedString} */ ("Commande automate pompe gauche/haute")
});
export { ahu_history_key_commandautomatep12 as "ahu_history_key_commandAutomateP1" }